// extracted by mini-css-extract-plugin
export default {"container":"page_container__A+Ee2","title":"page_title__NL7xq","subtitle":"page_subtitle__1yAgt","content":"page_content__E2Tbc"};